mutation TagDelete($input: TagDeleteInput!) {
  tagDelete(input: $input) {
    deletedEntities {
      id
      rowTimestamp
    }
  }
}
